export const PROMO_MOD_FLAG = 'client_home_promo_mod_enabled';
